import { Category } from "../Model/Category";
import { CategoryRepository } from "../Repository/CategoryRepository";

export interface GetCategoryUseCase {
  invoke: () => Promise<Category[]>;
}

export class GetCategories implements GetCategoryUseCase {
  private categoryRepo: CategoryRepository;
  constructor(_CategoryRepo: CategoryRepository) {
    this.categoryRepo = _CategoryRepo;
  }

   invoke(){
    const getData = this.categoryRepo.getCategories();
    return getData;
  }
}